import Vuelidate from 'vuelidate'
import vuelidateErrorExtractor from 'vuelidate-error-extractor'

export default ({ Vue }) => {
  Vue.use(Vuelidate)
  Vue.use(vuelidateErrorExtractor, {
    i18n: 'validation'
  })
}
